export default __webpack_public_path__ + "static/media/mentor.29831e4a.jpg";